import React, { useState, useEffect } from 'react';
import Caret from 'library/icons/caret.svg';
import { resolve } from 'library/helpers/path-resolver';
import useShowMorePages from 'util/hoc/useShowMorePages';

const ColumnHeader = ({noMatchScore, noSort, handleSort, label, isSorting, sortBy, sortDirection}) => {
  const [isActiveSort, setActiveSort] = useState(!!isSorting);
  const [sortAsc, setSortAsc] = useState(sortDirection === 'asc');

  useEffect(() => {
    setActiveSort(isSorting);
  }, [sortAsc]);

  const handleClick = () => {
    if(noSort) return;
    setActiveSort(!isActiveSort);
    setSortAsc(!sortAsc);
    const sortDirection = !sortAsc ? 'asc' : 'desc';
    if(typeof handleSort === 'function') handleSort(sortBy, sortDirection);
  };

  return (
    <span style={{ justifyContent: 'flex-start' }} onClick={handleClick}>
      {label}
      {(!noSort && isSorting) && (
        <Caret className={['flip-then-rotate-180', sortDirection === 'asc' ? null: 'active'].filter(c=>c).join(' ')} />)
      }
    </span>
  );
};


const PeopleList = (props) => {

  const {
    graph_data,
    graph_loading,
    onMouseLeave,
    loading,
    limit,
    graph_results_resolve_path, // resolve(graph_data, 'users/results', [])
    mapPeople,
    peopleList,
    children,
    handleSort,
    currentSortColumn,
    setLimit,
    sortDirection,
    noSort,
    noMatchScore
  } = props;

  const isSorting = (sortByColumn) => (
    currentSortColumn === sortByColumn
  );

  const renderShowMorePages = () => {
    const count = Math.min(resolve(graph_data, graph_results_resolve_path, []).length, limit);
    const total = resolve(graph_data, 'users/pagination/total', null);

    return useShowMorePages({
      count,
      loading: graph_loading || loading,
      total,
      setLimit: setLimit,
      limit: limit
    });
  };

  return (
    <div onMouseLeave={onMouseLeave} className="hiring-evaluate-sidebar-list">
      <div className="hiring-evaluate-sidebar-header">
        <ColumnHeader
          handleSort={handleSort}
          label='FIRST NAME'
          isSorting={isSorting('first_name')}
          sortDirection={sortDirection}
          sortBy='first_name'
          noSort={noSort} />
        <ColumnHeader
          handleSort={handleSort}
          label='LAST NAME'
          isSorting={isSorting('last_name')}
          sortDirection={sortDirection}
          sortBy='last_name'
          noSort={noSort} />
        <ColumnHeader
          handleSort={handleSort}
          label={noMatchScore ? null : 'MATCH SCORE'}
          isSorting={isSorting('match')}
          sortDirection={sortDirection}
          sortBy='match'
          noSort={noSort} />
      </div>
      {
        resolve(peopleList, 'length', false) ? peopleList.map(mapPeople) : null
      }
      { renderShowMorePages() }
      { children }
    </div>
  );
};

export default PeopleList;